import keyBy from 'lodash/keyBy';
import cloneDeep from 'lodash/cloneDeep';
import { pick } from 'lodash';

export default {
  units: state => state.units.filter(unit => unit.status.display_default),
  currentUnit: state => state.currentUnit,
  crop: state => state.crop,
  unitById: (_, getters) => {
    const index = keyBy(getters.units, 'unit_id');
    return unitId => index[unitId];
  },
  favourites: state => state.favourites,
  normalizedUnits: (state, getters, rootState, rootGetters) => getters.units.map(unit => normalizeUnit(
    unit,
    rootGetters['unitTypes/unitTypeById'](unit.unit_type_id),
    rootGetters['project/statuses'],
  )),
  normalizedUnitById: (_, getters) => {
    const index = keyBy(getters.normalizedUnits, 'unit_id');
    return unitId => index[unitId];
  },
};

// /////////////////////////////////////////
function normalizeUnit(unit, unitType, statuses) {
  const normalized = Object.assign(pick(unit, ['name', 'status', 'unit_id']), {
    unit,
    attributes: cloneDeep(unit.attributes),
    formattedAttributes: cloneDeep(unit.formatted_attributes),
  });

  // unique keys
  const attributesMeta = new Set(Object.keys(unit.attributes)
    .concat(unitType ? Object.keys(unitType.attributes) : []));

  if (unitType) {
    attributesMeta.forEach((key) => {
      if (isNotEmpty(unitType.formatted_attributes[key])) {
        normalized.formattedAttributes[key] = decodeURIComponent(unitType.formatted_attributes[key]);
      } else if (isNotEmpty(unitType.attributes[key])) {
        normalized.attributes[key] = unitType.attributes[key];
      }

      if (key === 'size_gross') {
        normalized.attributes.size_gross_num = setNormalizedSizeGross(unit, unitType);
        normalized.formattedAttributes.size_gross = setNormalizedSize(unit, unitType);
      }
      if (key === 'rooms') {
        normalized.attributes.rooms = unit.attributes[key] || unitType.attributes[key];
      }
    });
  }

  if (unitType && Number.isFinite(unitType.attributes.floors_internal)) {
    normalized.attributes.floor_ext_int_num = parseInt(unitType.attributes.floors_internal, 10);
  }
  if (Number.isFinite(unit.attributes.floor_external)) {
    normalized.attributes.floor_ext_int_num = parseInt(unit.attributes.floor_external, 10);
  }

  if (isPriceAttributeHidden(unit, statuses)) {
    normalized.formattedAttributes.fee_monthly = 0;
    normalized.formattedAttributes.price = 0;
    normalized.attributes.fee_monthly = 0;
    normalized.attributes.price = 0;
  }

  if (normalized.status.position == null) {
    normalized.status.position = Number.POSITIVE_INFINITY;
  }

  return normalized;
}

function setNormalizedSizeGross(unit, unitType) {
  const key = 'size_gross';
  if (unit.attributes.size_gross) { // && unit.attributes.size_gross_num == null dont know why check for null
    return parseFloat(unit.attributes[key]);
  } else if (unitType.attributes[key]) {
    return parseFloat(unitType.attributes[key]);
  }
  return '';
}
function setNormalizedSize(unit, unitType) {
  const key = 'size_gross';
  if (unit.formatted_attributes.size_gross) {
    return unit.formatted_attributes[key];
  } else if (unitType.formatted_attributes[key]) {
    return unitType.formatted_attributes[key];
  }
  return '';
}

function isNotEmpty(value) {
  return value || value === 0;
}

function isPriceAttributeHidden(unit, statuses) {
  const status = statuses.find(status => status.status_id === unit.status.status_id);

  return !status.display_price;
}
